import { render, staticRenderFns } from "./settlementList.vue?vue&type=template&id=9c310ff4&scoped=true&"
import script from "./settlementList.vue?vue&type=script&lang=js&"
export * from "./settlementList.vue?vue&type=script&lang=js&"
import style0 from "./settlementList.vue?vue&type=style&index=0&id=9c310ff4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c310ff4",
  null
  
)

export default component.exports